export const StatusConfig = {
  green: {
    color: 'status-green',
    text: 'Open',
    icon: '✅'
  },
  yellow: {
    color: 'status-yellow',
    text: 'Busy',
    icon: '🕐'
  },
  orange: {
    color: 'status-orange',
    text: 'Very Busy',
    icon: '👥'
  },
  closed: {
    color: 'status-closed',
    text: 'Closed',
    icon: '❌'
  }
};